// THIS FILE IS AUTO-GENERATED BY FIGMAGIC. DO NOT MAKE EDITS IN THIS FILE! CHANGES WILL GET OVER-WRITTEN BY ANY FURTHER PROCESSING.

const fontWeights = {
  mega: 700,
  bold: 700,
  regular: 400,
  medium: 500,
  semibold: 600,
  button: 700,
  buttonS: 600,
  label: 400,
  labelSemibold: 600
} as const;

export default fontWeights;
